import { normalizeString } from "./stringUtils"

// Asume nombreUso ya normalizado
export const isNoMeasureUso = (nombreUso) => {
    let noMeasureUsos = [
        "Componente de Equipo Industrial",
        "Ambiental",
        "Componente de Equipo Médico",
    ]
    return noMeasureUsos.some(uso => nombreUso.includes(normalizeString(uso)))
}